import React from 'react';
import CustomButton from '@components/layout/Header/SP/CustomButton';

export default function ContactAndRequestButtons(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center space-y-4">
      <CustomButton href="https://renovefudosan.com/lp/inquiry_check/" label="お問い合わせ" handleClick={() => {}} />
      <CustomButton href="https://renovefudosan.com/request/" label="資料請求" handleClick={() => {}} />
    </div>
  );
}
